export default function ExamFooter({
  canGoBack,
  onBack,
  onReview,
  onNext
}) {
  return (
    <div className="p-4 border-t bg-white flex justify-between">
      <button
        disabled={!canGoBack}
        onClick={onBack}
        className="border px-4 py-2 rounded disabled:opacity-40"
      >
        ← Back
      </button>

      <div className="flex gap-3">
        <button
          onClick={onReview}
          className="border px-4 py-2 rounded"
        >
          Mark for Review
        </button>

        <button
          onClick={onNext}
          className="bg-blue-600 text-white px-6 py-2 rounded"
        >
          Save & Next →
        </button>
      </div>
    </div>
  );
}
